import { getNotificationsForContact } from '../../graphql/queries';
import {
  LIST_NOTIFICATIONS_REQUESTED,
  LIST_NOTIFICATIONS_COMPLETED,
  LIST_NOTIFICATIONS_FAILED,
} from './types';
import api from '../../services/api';
import debug from '../../services/debug';

// https://docs.amplify.aws/lib/graphqlapi/getting-started/q/platform/js#enable-queries-mutations-and-subscriptions
// https://docs.amplify.aws/cli/graphql-transformer/dataaccess
const listAction = () => async (dispatch, getState) => {
  dispatch({
    type: LIST_NOTIFICATIONS_REQUESTED,
  });

  try {
    const { contacts } = getState();
    const contact = contacts.get('set');
    const { data } = await api.graphql({
      query: getNotificationsForContact,
      variables: {
        ContactID: contact.ContactID,
      },
    });

    dispatch({
      type: LIST_NOTIFICATIONS_COMPLETED,
      payload: data.getNotificationsForContact,
    });
  } catch (err) {
    debug(LIST_NOTIFICATIONS_FAILED, err);

    dispatch({
      type: LIST_NOTIFICATIONS_FAILED,
      payload: err,
    });
  }
};

export default listAction;
